import { AddonSettings } from '@ancon/wildcat-types'

/** A group the customer has to choose from before adding the product */
export default function isAddonGroupRequired(addOnSettings: AddonSettings) {
  return (addOnSettings.minimumAmount ?? 0) > 0
}
